"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Rule = void 0;
const token_1 = require("./token");
class Rule {
    constructor(regex, tokenType) {
        this.regex = new RegExp(`^${regex.source}`, regex.flags);
        this.tokenType = tokenType;
    }
    tryParse(text) {
        const result = this.regex.exec(text);
        if (result === null) {
            return null;
        }
        return new token_1.Token(this.tokenType, result[0]);
    }
    toString() {
        return `${this.regex}: ${this.tokenType}`;
    }
}
exports.Rule = Rule;
//# sourceMappingURL=rule.js.map